import component from './component'
import { connect } from 'react-redux'
import {
  MODAL
} from '../../reduxs'

function mapStateToProps (state, ownProps) {
  return {
    permission: state.accountReducer.permission,
    language: state.accountReducer.language,
    username: state.accountReducer.user.username,
    modalStatus: state.modalReducer.status,
    userCompany: state.accountReducer.user.companyId,
    minuteStep: state.accountReducer.user.minuteStep,
    startOperatingTime: state.accountReducer.user.startOperatingTime,
    endOperatingTime: state.accountReducer.user.endOperatingTime,
    floor: state.floorReducer.listFloor,
    settingTheme: state.settingReducer.settingTheme
  }
}

function mapDispatchToProps (dispatch) {
  return {
    openModalStatus: (div) => dispatch(MODAL.action.openModalStatus(div)),
    closeModalStatus: () => dispatch(MODAL.action.closeModalStatus())
  }
}

export default connect(
  (state, ownProps) => mapStateToProps(state, ownProps),
  (dispatch) => mapDispatchToProps(dispatch)
)(component)
